async function generateFileFingerprint(file) {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return `sha256:${hashHex}`;
}

/**
 * Extracts up to two initials from a full name.
 * @param {string} name - The full name (e.g., "Arya Sam")
 * @returns {string} The initials (e.g., "AS")
 */
const getInitials = (name) => {
  if (!name || typeof name !== 'string') return "";

  const names = name.trim().split(/\s+/);

  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }

  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

export {
  generateFileFingerprint,
  getInitials
};


export function parseLocalDateOnly(value) {
  if (!value) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  return new Date(value);
}

export function isDeadlinePassed(contentDeadline) {
  const deadline = parseLocalDateOnly(contentDeadline);
  if (!deadline || Number.isNaN(deadline.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  deadline.setHours(0, 0, 0, 0);

  return today > deadline;
}